export const SHOW_TODAY_WARNING = 'SHOW_TODAY_WARNING'
export const HIDE_TODAY_WARNING = 'HIDE_TODAY_WARNING'

export const FIRST_INPUT = 'FIRST_INPUT'
export const SECOND_INPUT = 'SECOND_INPUT'
